<template>
  <div class="app">
    <template v-if="show_Header_Footer">
      <AppHeader fixed class="style-header">
        <b-link class="navbar-brand" :to="{ name: 'Home' }">
          <img
            class="navbar-brand-full"
            :src="$config.getAssetsURL('img/logo.png')"
            width="130"
            height="30"
            alt="Agriweather"
          />
          <img
            class="navbar-brand-minimized"
            :src="$config.getAssetsURL('img/brand/AgriBanRen.png')"
            width="30"
            height="30"
            alt="Agriweather"
          />
        </b-link>

        <!-- 快捷功能 ( d-md-down-none 設定視窗不夠寬 md 就會不見的區域 ) -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            id="language-selector"
            :text="$t('menu.language')"
            right
          >
            <b-dropdown-item @click="switchLang('zh-Hant-TW')"
              >正體中文</b-dropdown-item
            >
            <!-- <b-dropdown-item @click="switchLang('ja')">日本語</b-dropdown-item> -->
            <b-dropdown-item @click="switchLang('en')">English</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </AppHeader>
      <div class="app-body" id="app-printer">
        <router-view></router-view>
      </div>
      <TheFooter class="footer-center">
        <!--footer-->
        <div class="footer-center-text">
          <a href="https://cloud.agriweather.online">AgriCloud</a>
          {{ system_version }}
          <span v-if="system_version_FrontEnd != undefined"
            >| {{ system_version_FrontEnd }}</span
          >
          <span class="ml-1"
            >&copy; {{ thisYear }}
            <a href="https://www.agriweather.online" target="blank"
              >阿龜微氣候 AgriWeather</a
            >,
            <a href="https://www.beehivedt.com" target="blank"
              >蜂巢數據科技股份有限公司 Beehive Data Technology Co., Ltd.</a
            >
            All Rights Reserved.</span
          >
        </div>
      </TheFooter>
    </template>
    <template v-else>
      <div id="app-printer">
        <router-view></router-view>
      </div>
    </template>
  </div>
</template>

<script>
import { Header as AppHeader, Footer as TheFooter } from "@coreui/vue";
import { mapState } from "vuex";

export default {
  name: "door",
  components: {
    AppHeader,
    TheFooter,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      system_version: (state) => state.system.version,
      system_version_FrontEnd: (state) => state.system.version_FrontEnd,
      user_language: (state) => state.user.language,
    }),

    thisYear() {
      return new Date().getFullYear(); // 取得當下年份
    },

    show_Header_Footer() {
      switch (this.$route.name) {
        case "Download Page":
          return false;
        default:
          return true;
      }
    },
  },
  mounted() {
    this.$store
      .dispatch("system/getVersion")
      .then((res) => {})
      .catch((err) => {});

    if (this.$route.query.lang != undefined) {
      this.switchLang(this.$route.query.lang);
    } else if (this.user_language != undefined) {
      this.switchLang(this.user_language);
    } else if (localStorage.getItem("locale") != undefined) {
      this.switchLang(localStorage.getItem("locale"));
    } else {
      this.switchLang("en");
    }
  },
  methods: {
    switchLang(newLang) {
      switch (newLang) {
        case "zh-Hant-TW":
          break;
        default:
          newLang = "en";
          break;
      }
      this.$i18n.locale = newLang;
      localStorage.setItem("locale", newLang);
      this.$store.commit("user/setLanguage", newLang);
      // console.log( 'set: ' + newLang )
      // console.log( 'user lang: ' + this.user_language )
    },
  },
};
</script>


<style lang="scss" scoped>
#language-selector {
  margin-right: 10px;

  // 畫面寬度過小，調整國旗 icon 縮小靠下
  @media only screen and (max-width: 350px) {
    padding-top: 30px;
  }
}
</style>
